import Footer from './components/Footer'
import React from 'react'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import {myConfig} from './config/myConfig'
import Main from './components/Main'

import DialogInfo from './components/DialogInfo'

//import Container from "./wrapper/Container"

const muiTheme = getMuiTheme({
  palette: { primary1Color: myConfig.blue},
  appBar: { height: 50}
})



class App extends React.Component {

  render() {

    return (

      <MuiThemeProvider muiTheme={muiTheme}>
         <div>
         {/*<DialogInfo/> */}
           <Main/>
           <p style={{color:myConfig.blueLight,fontSize:12,textAlign:'center'}}>
           La date hégirienne n’est qu’à titre informative. <br/>
           Il faut s’en tenir aux annonces des organismes officiels et compétents pour avoir la date exacte à chaque entrée de mois.
           </p>

           <Footer/>



         </div>
       </MuiThemeProvider>

    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js